import styled from 'styled-components';

const StyledGoToManifesto = styled.div`
  position:  relative;
  padding: 0 0 ${props => props.theme.components_spacing_desk.xlarge}px;
  text-align: center;
  height: 100vh;
  background-color: #000;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  
  .text--wrap{
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    color: #fff;
    z-index: 2;
  }
  .text--wrap h5{
    margin-bottom: 35px;
  }
  .text--wrap h5 span {
    color: ${props => props.theme.colors.green_secondary};
  }
  .text--wrap p {
    color: #fff;
  }

  .text--wrap img{
    width: 16px;
  }
  @media screen and (max-width: 1439px){
    
  }
  @media screen and (max-width: 1023px){
    padding-bottom: ${props => props.theme.components_spacing_tablet.xlarge}px;
    height: 60vh;
  }
  @media screen and (max-width: 767px){
    padding-bottom: ${props => props.theme.components_spacing_mobile.xlarge}px;
   
  }
`;
export {
  StyledGoToManifesto,
};

